import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import LegalPage from './components/legal/LegalPage';
import ServiceFormPage from './components/service/ServiceFormPage';
import { getLegalPageByPath } from './data/legal';
import { getServiceBySlug } from './data/services';
import './App.css';

const getCurrentPath = () => window.location.pathname.replace(/\/+$/, '') || '/';

const ServicePageFallback = () => (
  <main className="service-fallback">
    <div className="container service-fallback__inner">
      <h1>Service not found</h1>
      <p>The service page you requested is not available right now.</p>
      <a className="service-fallback__link" href="/#services">
        Return to services
      </a>
    </div>
  </main>
);

const App = () => {
  const currentPath = getCurrentPath();
  const isServicePage = currentPath === '/services' || currentPath.startsWith('/services/');
  const serviceSlug = currentPath.startsWith('/services/')
    ? currentPath.replace('/services/', '')
    : '';
  const activeLegalPage = getLegalPageByPath(currentPath);
  const activeService = serviceSlug ? getServiceBySlug(serviceSlug) : null;

  return (
    <div className="app">
      <Navbar />
      {activeLegalPage ? (
        <LegalPage page={activeLegalPage} />
      ) : isServicePage ? (
        activeService ? (
          <ServiceFormPage service={activeService} />
        ) : (
          <ServicePageFallback />
        )
      ) : (
        <main>
          <Hero />
          <Services />
          <About />
          <Contact />
        </main>
      )}
      <Footer />
    </div>
  );
};

export default App;
